import { Card, ListGroup } from "react-bootstrap";
import { AiOutlineFileDone } from "react-icons/ai";
import { FiAlertOctagon, FiAlertTriangle, FiCheckCircle } from "react-icons/fi";
import { BsFillHexagonFill } from "react-icons/bs";
import { FiBell } from "react-icons/fi";
import { MdPostAdd } from "react-icons/md";
import { colors, styleScreenDashboard } from "../styles/style";
//import CheckType from "../utilities/dateFormat/checkType";

const Help = () => {
  //var currentDateToString = CheckType("current");
  const amount = [
    "En caso de que el repartidor NO haya recibido pago en efectivo el indicador será verde.",
    "En caso de que el monto acumulado en efectivo sea menor a $500 el indicador será amarillo.",
    "En caso de que el monto acumulado en efectivo sea mayor o igual a $500, el indicador se mostrara en color rojo.",
  ];

  const distance = [
    "En caso de que el repartidor se encuentre a 2km o menos, el indicador será verde y tendrá una leyenda 'Cerca'.",
    "En caso de que el repartidor se encuentre a 5km o menos, el indicador será amarillo y tendrá una leyenda 'No muy lejos'",
    "En caso de que el repartidor se encuentre a mas de 5km, el indicador será rojo y tendrá una leyenda 'Lejos'",
    "En caso de que el repartidor se encuentre conectado pero tenga algún error que no permita conocer su ubicación, el indicador será de color gris y tendrá una leyenda 'Desconocido'",
  ];

  const levels = [
    "El icono en forma de hexagono toma el color negro cuando no hay registros del nivel del repartidor",
    "El color azul es para aquellos repartidores que se encuentren en el nivel entrenamiento",
    "El color cobre es para aquellos repartidores que se encuentren en el nivel cobre",
    "El color plata/gris es para aquellos repartidores que se encuentren en el nivel plata",
    "El color amarillo es para aquellos repartidores que se encuentren en el nivel oro",
  ];

  const ListRender = ({ list }) => {
    return (
      <ListGroup variant="flush">
        {list.map((item) => (
          <ListGroup.Item>{item}</ListGroup.Item>
        ))}
      </ListGroup>
    );
  };

  return (
    <div style={styleScreenDashboard.principalContainer}>
      <div className="container">
        <div className="row">
          <div
            className="col container margin-right-1"
            style={styleScreenDashboard.containerColumn}
          >
            <Card>
              <Card.Header as="h5">Asignación de ordenes</Card.Header>
              <Card.Body>
                <Card.Title>Repartidores</Card.Title>
                <ListGroup className="list-group-flush">
                  <ListGroup.Item>
                    <div className="row mt-1 mb-2">
                      <div className="col-7 h6">Niveles</div>
                      <div className="col row align-items-center d-flex justify-content-center">
                        <div className="col">
                          <BsFillHexagonFill color={"black"} />
                        </div>
                        <div className="col">
                          <BsFillHexagonFill color={"#81b0e8"} />
                        </div>
                        <div className="col">
                          <BsFillHexagonFill color={"#9F7A34"} />
                        </div>
                        <div className="col">
                          <BsFillHexagonFill color={"#B5B7BB"} />
                        </div>
                        <div className="col">
                          <BsFillHexagonFill color={"#D4AF37"} />
                        </div>
                      </div>
                    </div>
                    <Card body>
                      Este indicador permite saber el nivel actual del
                      repartidor.
                      <ListRender list={levels} />
                    </Card>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <div className="row mb-2">
                      <div className="col-8 h6">
                        Número de ordenes atendidas por semana
                      </div>
                      <div className="col d-flex justify-content-center">
                        <AiOutlineFileDone
                          size={25}
                          color={colors.BLUE_COLOR}
                        />
                      </div>
                    </div>
                    <Card body>
                      Este indicador permite saber la cantidad de ordenes que ha
                      atendido el repartidor durante la semana en curso
                    </Card>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <div className="row mt-1 mb-2">
                      <div className="col-8 h6">Monto acumulado</div>
                      <div className="col row align-items-center d-flex justify-content-center">
                        <div className="col">
                          <FiCheckCircle size={20} color={colors.GREEN_COLOR} />
                        </div>
                        <div className="col">
                          <FiAlertTriangle
                            size={20}
                            color={colors.YELLOW_COLOR}
                          />
                        </div>
                        <div className="col">
                          <FiAlertOctagon size={20} color={colors.RED_ALERT} />
                        </div>
                      </div>
                    </div>
                    <Card body>
                      Este indicador permite saber el monto que ha acumulado el
                      repartidor en compras en efectivo.
                      <ListRender list={amount} />
                    </Card>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <div className="row mt-1">
                      <div className="col-8 h5">Distancia</div>
                      <div className="col row d-flex justify-content-center">
                        <div className="col">
                          <div
                            style={{
                              height: 15,
                              width: 15,
                              borderRadius: 50,
                              backgroundColor: colors.GREEN_COLOR,
                            }}
                          />
                        </div>
                        <div className="col">
                          <div
                            style={{
                              height: 15,
                              width: 15,
                              borderRadius: 50,
                              backgroundColor: colors.YELLOW_COLOR,
                            }}
                          />
                        </div>
                        <div className="col">
                          <div
                            style={{
                              height: 15,
                              width: 15,
                              borderRadius: 50,
                              backgroundColor: colors.RED_ALERT,
                            }}
                          />
                        </div>
                        <div className="col">
                          <div
                            style={{
                              height: 15,
                              width: 15,
                              borderRadius: 50,
                              backgroundColor: colors.GRAY_3_COLOR,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <Card body>
                      Este indicador permite saber a que distancia se encuentra
                      el repartidor.
                      <ListRender list={distance} />
                    </Card>
                  </ListGroup.Item>
                </ListGroup>
              </Card.Body>
            </Card>
          </div>
          <div
            className="col container margin-left-1"
            style={styleScreenDashboard.containerColumn}
          >
            <Card>
              <Card.Header as="h5">Ordenes pendientes</Card.Header>
              <Card.Body>
                <ListGroup.Item>
                  <div className="row mb-2">
                    <div className="col-8 h6">Íconos en la orden</div>
                    <div className="col d-flex justify-content-center">
                      <div className="col">
                        <MdPostAdd size={20} color={colors.GRAY_2_COLOR} />
                      </div>
                      <div className="col">
                        <FiBell size={20} color={colors.YELLOW_COLOR} />
                      </div>
                    </div>
                  </div>
                  <Card body>
                    El ícono de campana permite realizar recordatorios a la
                    tienda por medio de notificaciones y el otro ícono permite
                    conocer los detalles de la orden
                  </Card>
                </ListGroup.Item>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;
